
import {useEffect} from 'react';
import {CollectionGallery} from '../../../components/User_Side/collection_gallery/collection_gallery';
import {useTranslation} from 'react-i18next';
import {useProductsByCategory} from "../../../hooks/useProductsByCategory";
import {Element} from "react-scroll";
import {useTrackVisit} from "../../../hooks/useTrackVisit";

const CategoryPage = ({props}: {
    props: {
    category: any;
} }) => {
    const { collections, loading, fetchProducts } = useProductsByCategory(props.category.name);
    const {t} = useTranslation();
    const trackVisit = useTrackVisit();

    useEffect(() => {
        trackVisit(props.category.name.toLowerCase());
    }, [props.category.name]);

    useEffect(() => {
        fetchProducts()
    }, [fetchProducts]);

    return (
        <Element
            id={props.category.name.toLowerCase()}
            name={props.category.name.toLowerCase()}>
        <div className={`Category-Page`}>
            <div className="textes-wrapper">
                <div className="section-paragraph">
                    <h3 className="section-title">{t(`menu.${props.category.name.toLowerCase()}`, {defaultValue: props.category.name})}</h3>

                    <div>
                        <CollectionGallery key={props.category.name}
                                           props={{
                            category: props.category,
                            collections: collections,
                            loading: loading,
                        }}/>
                    </div>
                </div>
            </div>
        </div>
        </Element>
    );
};

export default CategoryPage;
